// LibraryCommittee.jsx
import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "./libraryCommittee.css";
import PageHeader from "../about/PageHeader";


const LibraryCommittee = () => {
  return (
    <div className="lc-root">
      <Navbar />
       <PageHeader
                title="Library Committee"
                crumbs={[
                  { label: "Home", href: "/" },
                  { label: "Library Committee" },
                ]}
              />

       <div className="lib-container">
      {/* Main */}
     
        <div className="lc-layout">
          {/* Table */}
          <div className="lc-committee-table-wrap">
            <table className="lc-committee-table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td><strong>Dr. Pravin Gundalwar</strong></td>
                  <td>Director</td>
                  <td>
                  
                    Chairperson
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td><strong>Ms. Kiran Dubey</strong></td>
                  <td>Librarian</td>
                  <td>
    
                    Member - Secretary
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td><strong>Dr. Ashwini Renavikar</strong></td>
                  <td>Professor & HoD MCA Integrated</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td><strong>Prof. Shirshendu Maitra</strong></td>
                  <td>Asst. Professor & HoD - ACA MCA</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td><strong>Prof. Rupali Jadhav</strong></td>
                  <td>Asst. Professor</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td><strong>Prof. Kinjal Doshi</strong></td>
                  <td>Asst. Professor</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td><strong>Mr. Pranit Halady</strong></td>
                  <td>Sem I Batch A</td>
                  <td>
                    
                    Student Representative
                  </td>
                </tr>
                <tr>
                  <td>8</td>
                  <td><strong>Mr. Shashwat Pandey</strong></td>
                  <td>Sem I Batch B</td>
                  <td>
                   
                    Student Representative
                  </td>
                </tr>
                <tr>
                  <td>9</td>
                  <td><strong>Ms. Swati Singh</strong></td>
                  <td>Sem I Batch C</td>
                  <td>
                  
                    Student Representative
                  </td>
                </tr>
                <tr>
                  <td>10</td>
                  <td><strong>Ms. Jyoti Upadhyay</strong></td>
                  <td>Sem I Batch D</td>
                  <td>
                   
                    Student Representative
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Right column */}
          <div className="lc-right">
            {/* Image card */}
            <div className="lc-image-card">
              <div className="lc-image-glow" />
              <div className="lc-image-inner">
                <img
                  className="lc-image"
                  alt="Modern college library interior with students studying"
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuD_MzXjtDgvd3pVZDIw2JzitSFY_R-FgTh0OeMwACYN-_FfHoi6WK1nVwz3HC1CEjY_y44aJ37Oi-3mcGrleF_9UuuO7KHl5FrcBNu_v60ES15f9HJzNmIOX0oC_mhXwvTWSSuyH4giRy7x1OjAT68zlwyyANZjZHAhqiE5-9YQ8D8UULnDVYONqDA60yO4m4ZDh-Iuyz7ee_pbHF-kunfzOTp_4lPyPGxqEjioBmlSGwh-qjVme6LVTKT7x3w3oJf-CHTnoNCrK74"
                />
                <div className="lc-image-caption">
                  <div className="lc-image-text">
                    Our library provides a modern learning environment for all
                    students.
                  </div>
                </div>
              </div>
            </div>

            {/* About card */}
            <div className="lc-about">
              <div className="lc-about-header">
                <span>About the Committee</span>
              </div>
              <div className="lc-about-text">
                The Library Committee is responsible for overseeing the
                development of library resources, policies, and services to
                support the academic excellence of our institution.
              </div>
           
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
   
    
  );
};

export default LibraryCommittee;
